import useClientMutation from './useClientMutation';

export type { ClientMutationCacheKey } from './useClientMutation';

export default useClientMutation;
